import React from "react";

function DogDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="product-details">
            <h3>İt Məlumatları</h3>
            <div className="product-details-grid">
                <ul>
                    <li><strong>Ad:</strong> {product.name || "Bilinmir"}</li>
                    <li><strong>Cins:</strong> {product.dogBreed || "Bilinmir"}</li>
                    <li><strong>Yaş:</strong> {product.age ? `${product.age} yaş` : "Bilinmir"}</li>
                    <li><strong>Cinsiyyət:</strong> {product.gender || "Bilinmir"}</li>
                    <li><strong>Çəki:</strong> {product.weight ? `${product.weight} kq` : "Bilinmir"}</li>
                    <li><strong>Rəng:</strong> {product.color || "Bilinmir"}</li>
                </ul>
                <ul>
                    <li><strong>Sağlamlıq vəziyyəti:</strong> {product.healthStatus || "Bilinmir"}</li>
                    <li><strong>Peyvəndlər:</strong> {product.vaccinated ? "Bəli" : "Xeyr"}</li>
                    <li><strong>Şəcərə:</strong> {product.pedigree ? "Bəli" : "Xeyr"}</li>
                    <li><strong>Aksesuarlar daxildir:</strong> {product.includesAccessories ? "Bəli" : "Xeyr"}</li>
                    <li><strong>Şəhər:</strong> {product.city || "Bilinmir"}</li>
                </ul>
            </div>
            <div className="product-details-description">
                <strong>Əlavə təsvir:</strong>
                <p>{product.description || "Açıqlama mövcud deyil."}</p>
            </div>
        </div>
    );
}

export default DogDetails;